module.exports = __webpack_public_path__ + "img/30.47107c0b.jpg";